import { getNewUnwindingEpochs } from "@/services";
import { getNextEpoch } from "@/utils";
import { type UnwindingPositionStore, useDialogPortal, useLockedPositionAPY } from "@/hooks";
import { useMemo, useState } from "react";
import { useInterval } from "usehooks-ts";

export const useUnwindingPositionItem = (position: UnwindingPositionStore) => {
    const { apy } = useLockedPositionAPY(Number(position.lockDuration.slice(0, -1)));
    const { openCancelExitTransactionDialog, openWithdrawUnwoundDialog } = useDialogPortal();
    const endDateMs = useMemo(() => Date.parse(position.endDate), [position.endDate]);
    const [nowMs, setNowMs] = useState(() => Date.now());

    useInterval(
        () => {
            setNowMs(Date.now());
        },
        Number.isNaN(endDateMs) || nowMs >= endDateMs ? null : 1000,
    );

    const timeRemaining = Number.isNaN(endDateMs) ? 0 : endDateMs - nowMs;
    const canCancel = timeRemaining > 0 && getNextEpoch() - 1 >= position.startUnwindingEpoch;

    const handleCancelExit = () => {
        const newUnwindingEpochs = getNewUnwindingEpochs(position.epochsRemaining, position.startUnwindingTimestampMs);

        openCancelExitTransactionDialog({
            position,
            newUnwindingEpochs: Number(newUnwindingEpochs),
            unwindingTimestampMs: position.startUnwindingTimestampMs,
        });
    };

    const handleFinalizeWithdrawal = () => {
        openWithdrawUnwoundDialog({
            amount: Number(position.lockedBalance),
            unwindingTimestamp: position.startUnwindingTimestampMs,
        });
    };

    return {
        apy,
        timeRemaining,
        canCancel,
        handleCancelExit,
        handleFinalizeWithdrawal,
    };
};
